import React from "react";

export const Logo = () => {
  return (
    <svg
      viewBox="0 0 69.999999 12.02997"
      version="1.1"
      width="70"
      height="12.02997"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        className="cls-2"
        clip-path="url(#clippath)"
        id="g27"
        transform="matrix(0.05119354,0,0,0.05119354,0,-5.119354e-4)"
      >
        <g id="g25">
          <path
            d="m 280.94,228.84 -23.7,-54.65 h -12.95 v 54.65 H 181.11 V 7.74 h 80.87 c 53.38,0 85.91,31.91 85.91,83.07 0,28.74 -11.37,52.43 -31.27,66.97 l 32.22,71.07 h -67.9 z M 244.29,52.59 v 76.76 h 10.43 c 18.95,0 29.06,-13.9 29.06,-38.53 0,-24.63 -10.43,-38.22 -28.74,-38.22 H 244.3 Z"
            id="path9"
          />
          <path
            d="M 362.65,228.84 V 7.74 h 123.19 v 47.69 h -60.01 v 40.12 h 60.01 v 46.12 h -60.01 v 39.48 h 60.01 v 47.69 z"
            id="path11"
          />
          <path
            d="M 539.07,228.84 V 55.44 H 498.32 V 7.74 h 144.67 v 47.69 h -40.75 v 173.41 h -63.18 z"
            id="path13"
          />
          <path
            d="M 655.49,153.36 V 7.74 h 63.49 v 144.67 c 0,18.01 8.21,28.42 21.48,28.42 13.27,0 21.48,-10.43 21.48,-28.42 V 7.74 h 63.49 v 145.62 c 0,52.43 -30.96,81.49 -84.97,81.49 -54.01,0 -84.97,-29.37 -84.97,-81.49 z"
            id="path15"
          />
          <path
            d="m 941.01,228.84 -23.7,-54.65 h -12.95 v 54.65 H 841.18 V 7.74 h 80.87 c 53.38,0 85.92,31.91 85.92,83.07 0,28.74 -11.38,52.43 -31.27,66.97 l 32.22,71.07 H 941.01 Z M 904.37,52.59 v 76.76 h 10.43 c 18.96,0 29.05,-13.9 29.05,-38.53 0,-24.63 -10.43,-38.22 -28.74,-38.22 h -10.75 z"
            id="path17"
          />
          <path
            d="M 1022.73,228.84 V 7.74 h 57.18 l 53.7,119.4 V 7.74 h 57.8 v 221.11 h -57.17 l -53.38,-116.87 v 116.87 h -58.13 z"
            id="path19"
          />
          <path
            d="m 1325.99,101.08 -35.7,-16.42 c -14.53,-7.27 -21.79,-12.63 -21.79,-23.69 0,-10.11 6.01,-16.42 16.11,-16.42 11.36,0 18,8.21 18.32,25.27 l 59.69,11.03 V 69.82 c 0,-45.17 -27.16,-69.81 -76.13,-69.81 -48.97,0 -77.38,25.58 -77.38,66.02 0,31.91 16.11,52.43 48.33,66.65 l 29.69,12.95 c 13.58,6.32 19.59,12.63 19.59,23.69 0,11.06 -6.64,17.69 -17.06,17.69 -13.27,0 -21.16,-10.11 -21.16,-29.06 l -61.59,-11.59 v 11.59 c 0,49.91 30.32,77.07 81.8,77.07 47.7,0 78.65,-26.22 78.65,-70.12 0,-29.69 -12.63,-49.91 -41.38,-63.8 h 0.01 z"
            id="path21"
          />
          <path
            d="m 134.65,119.78 -40.8,18.42 c 5.93,5.4 13.7,15.34 13.7,24.09 0,17 -8.5,26.15 -23.54,26.15 -15.04,0 -23.87,-9.15 -23.87,-26.15 0,-14.45 8.17,-22.66 19.93,-28.14 0.34,-0.15 0.68,-0.32 1.04,-0.48 l -0.02,-0.05 6.81,-3.08 c 7.12,-3.26 16.33,-7.44 25.55,-11.54 l 22.03,-9.95 C 150.52,100.84 163.43,85.87 163.43,61.6 163.45,22.37 130.12,0.79 84.02,0.79 c -46.1,0 -79.77,21.57 -79.77,60.8 0,19.82 11.29,36.71 25.86,45.5 L 72.29,88.05 C 67.62,83.17 63.11,74.36 63.11,66.5 c 0,-13.74 7.2,-22.89 20.92,-22.89 13.72,0 20.59,9.15 20.59,22.89 0,11.31 -4.79,19.15 -15.54,24.25 -8.4,3.99 -19.18,8.77 -31.4,14.24 l -20.11,9.08 C 17.36,123.41 0,140.23 0,169.16 c 0,40.87 31.71,65.06 84.02,65.06 52.31,0 84.02,-24.2 84.02,-65.06 0,-21.35 -17.3,-40.44 -33.39,-49.38 z"
            id="path23"
          />
        </g>
      </g>
    </svg>
  );
};
